// extracted by mini-css-extract-plugin
export default {"projects-container":"ProjectContainer_projects-container__xCddj"};